// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".line[data-v-2d73d972]{width:100%;height:1px;border:none;background-color:#969fa8}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
